export const API_ENDPOINTS = {
  baseURL: "https://www.limos.com",
  contest: "/contests.json",
};
